import { put, call, takeLatest } from 'redux-saga/effects';
// components
import { closeLoader, openLoader } from '../../../../components/loader/actions';
// helpers/constants
import * as GC from '../../../../constants';
// sagas
import { visitPageSaga } from '../../../../sagas';
// feature configs
import { getConfigByGroupSaga, getSequencesByTypeForConfigSaga } from '../../sagas';
//////////////////////////////////////////////////

function* handleVisitConfigServiceVendorPageSaga({ payload }) {
  while (true) { // eslint-disable-line
    yield call(visitPageSaga, payload, GC.CHECK_VISIT_CONFIG_SERVICE_VENDOR_PAGE);
    yield put(openLoader({ showDimmer: true }));
    yield call(getConfigByGroupSaga, GC.SERVICE_VENDOR_CONFIG_GROUP);
    yield call(getSequencesByTypeForConfigSaga, { payload: GC.SEQUENCE_TYPE_CARRIER });
    yield put(closeLoader());
    break;
  }
}

function* serviceVendorConfigWatcherSaga() {
  yield takeLatest(GC.VISIT_CONFIG_SERVICE_VENDOR_PAGE, handleVisitConfigServiceVendorPageSaga);
}

export default serviceVendorConfigWatcherSaga;
